<template>
  <div>


  <div v-if="clipBoard">
    <a :href="clipBoard" target="_blank">
      Endorsement Link
    </a>

  </div>

  <fragment v-if="steps.length > 0">
    <el-tree :data="steps"
             :props="defaultProps"
             @node-click="handleNodeClick"
             node-key="id"
             :render-content="renderContent"
    ></el-tree>
  </fragment>
  </div>
</template>

<script>
export default {
  name: "CommentStepTree",
  props: {
    steps: {
      type: Array
    },
    history: {
      type: Object
    }
  },
  data() {
    return {
      clipBoard: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
    methods: {
        async copyToClipboard(url) {
          try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Failed to fetch data: ${response.statusText}`);

            const text = await response.text(); // Extract text response
            this.clipBoard = text;
            await navigator.clipboard.writeText(text);
            this.$message.success("Response copied to clipboard!");
          } catch (error) {
            this.$message.error(`Failed to copy response: ${error.message}`);
          }
        },


      handleNodeClick(data) {
      },
      updateVisibility(data, checked) {
        axios.post('/screening-status/update-status-visibility', {
          nodeId: data.id, // Pass the unique node identifier
          status: data,
          includeInReport: checked // Pass the new state
        }).then(response => {
          this.$message.success('Status updated successfully!');
          data.include_in_report = checked; // Update the local state (if necessary)
        }).catch(error => {
          this.$message.error('Failed to update status.');
          console.error(error);
        });
      },
      remove(node, data) {
        this.$emit('node-delete', {
          node: node,
        });
      },
      edit(node, data) {
        debugger
        this.$emit('node-edit', {
          data: data,
        });
      },
      renderContent(h, {node, data, store}) {
        // Determine if the "Copy URL" button should be displayed

        const showCopyButton = this.history?.screening_endorsement &&
            data?.children && this.history.screening_endorsement.endorseable_id === data?.children[0]?.id;

        // Dynamic URL for clipboard copy
        const copyUrl = `/screening-endorsement/link/${this.history?.screening_endorsement?.id}`;

        return h('span', {
          style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap', // Prevent unnecessary wrapping
            margin: '5px 0',
            padding: '5px',
            width: '100%',
            overflow: 'hidden' // Ensure text overflow is handled
          }
        }, [
          // Label wrapped in a tooltip (only if truncated)
          h('el-tooltip', {
            props: {
              placement: 'top',
              effect: 'light',
            }
          }, [
            h("span", {
              ref: `label-${data.id}`, // Ref to check width programmatically
              domProps: {innerHTML: data.label}, // Render HTML content
              slot: "content" // Allows tooltip to render HTML
            }),

            h("span", {
              domProps: {innerHTML: data.label}, // Render HTML directly in tree
              style: {
                fontWeight: "bold",
                whiteSpace: "nowrap", // Keep it in one line
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: "1 1 auto",
                minWidth: "150px",
                maxWidth: "250px",
                cursor: "pointer"
              }
            })
          ]),

          // Checkbox (conditionally rendered)
          data.include_in_report !== undefined
              ? h('el-checkbox', {
                attrs: {value: data.include_in_report},
                style: {flexShrink: 0, minWidth: "120px"},
                on: {
                  change: (checked) => this.updateVisibility(data, checked)
                }
              }, 'Add to Report')
              : null,

          // Buttons (Edit, Delete, and Copy URL)
          data.showButtons ? h('span', {
            style: {
              display: "flex",
              flexWrap: "wrap",
              gap: "5px",
              marginLeft: "10px"
            }
          }, [
            h('el-button', {
              attrs: {size: 'mini', type: 'primary'},
              on: {click: () => this.edit(node, data)}
            }, 'Edit'),

            h('el-button', {
              attrs: {size: 'mini', type: 'danger'},
              on: {click: () => this.remove(node, data)}
            }, 'Delete'),

            // Conditionally render "Copy URL" button
            showCopyButton ? h('el-button', {
              attrs: {size: 'mini', type: 'success'},
              on: {click: () => this.copyToClipboard(copyUrl)}
            }, 'Copy URL') : null
          ]) : null
        ]);
      },

    }

};
</script>
<style>
.el-tree{
  padding-left: 10px;
  border-left: 2px solid #F5F7FA;
}
.el-tree-node{
  position: relative;
}
.el-tree-node:before{
  position: absolute;
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #adadad;
  left: -13px;
  top: 15px;
}
.el-tree-node > div:first-child{
  padding: 10px !important;
  min-height: 40px;
  background: #F5F7FA;
  margin: 5px auto;
}
</style>